import {BrowserModule,} from '@angular/platform-browser';
import {NgModule, ErrorHandler,} from '@angular/core';
import {FormsModule,} from '@angular/forms';
import {ReactiveFormsModule,} from '@angular/forms';
import {BrowserAnimationsModule,} from '@angular/platform-browser/animations';
import {HttpClientModule, HTTP_INTERCEPTORS,} from '@angular/common/http';
import {AppRoutingModule,} from 'app/app-routing.module';
import {App,} from '@pages/app';

// Angular Material Component
// Core modules
import {MatNativeDateModule,} from '@angular/material/core';
// No.1.Layout Series
import {MatSidenavModule,} from '@angular/material/sidenav';
import {MatCardModule,} from '@angular/material/card';
import {MatTabsModule,} from '@angular/material/tabs';
import {MatDividerModule,} from '@angular/material/divider';
import {MatSnackBarModule,} from '@angular/material/snack-bar';
import {MatDialogModule, MAT_DIALOG_DEFAULT_OPTIONS,} from '@angular/material/dialog';
import {MatProgressSpinnerModule,} from '@angular/material/progress-spinner';
import {MatStepperModule,} from '@angular/material/stepper';
import {MatExpansionModule,} from '@angular/material/expansion';
import {MatListModule,} from '@angular/material/list';
// No.2.Form Series
import {MatFormFieldModule, MAT_FORM_FIELD_DEFAULT_OPTIONS,} from '@angular/material/form-field';
import {MatInputModule,} from '@angular/material/input';
import {MatButtonModule,} from '@angular/material/button';
import {MatIconModule,} from '@angular/material/icon';
import {MatDatepickerModule,} from '@angular/material/datepicker';
import {MatSelectModule,} from '@angular/material/select';
import {MatRadioModule,} from '@angular/material/radio';
import {MatCheckboxModule,} from '@angular/material/checkbox';
import {MatSlideToggleModule,} from '@angular/material/slide-toggle';
import {MatAutocompleteModule,} from '@angular/material/autocomplete';
import {AutoCompleteModule,} from 'primeng/autocomplete';
import {MatTooltipModule,} from '@angular/material/tooltip';
import {MatBadgeModule,} from '@angular/material/badge';
// No.3.Table Series
import {MatTableModule,} from '@angular/material/table';
import {MatPaginatorModule,} from '@angular/material/paginator';
import {MatGridListModule,} from '@angular/material/grid-list';
// No.4.DatePicker Series for date formatting
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE,} from '@angular/material/core';
import {MomentDateAdapter,} from '@angular/material-moment-adapter';
// No.5.Error control
import {ErrorStateMatcher, ShowOnDirtyErrorStateMatcher,} from '@angular/material/core';

// Flex-layout
import {FlexLayoutModule,} from '@angular/flex-layout';

// Prime NG Component
import {PanelMenuModule,} from 'primeng/panelmenu';
import {TableModule,} from 'primeng/table';

// ngx-extended-pdf-viewer
import {NgxExtendedPdfViewerModule,} from 'ngx-extended-pdf-viewer';

// Services
import {
  SystemConstant,
  ScreenMessageHandler,
  LoginInfoService,
  HanyoMasterService,
  RequestInterceptor,
  HttpClientAsync,
  ScreenDefinitionProvider,
  ThrownErrorHandler,
  WindowStack,
  ValidationService,
  XmlMasterService,
} from '@services/index';

// Directives
import {YearMonthInputDirective,} from '@pages/directive/year-month-input-directive';
import {YearMonthDayInputDirective, MAT_MOMENT_DATE_FORMATS,} from '@pages/directive/year-month-day-input-directive';
import {FocusDirective,} from '@pages/directive/focus-directive';
import {CheckboxErrorState,} from '@pages/directive/checkbox-error-state';
import {MaxBytesLengthDirective,} from '@pages/directive/max-bytes-length-directive';
import {NativeElementInjectorDirective,} from '@pages/directive/native-element-injector-directive';
import {StepChangeDirective,} from '@pages/directive/step-change-directive';
import {YearMonthDayDtpDirective,} from '@pages/directive/year-month-day-dtp-directive';
import {InputRestrictDirective,} from './pages/directive/input-restrict.directive';

// Page Components
import {LoadingComponent,} from '@pages/loading/loading.component';
import {HeaderComponent,} from '@pages/header/header.component';
import {NotFoundComponent,} from '@pages/notfound/not-found.component';
import {SnackBarComponent,} from '@services/index';
import {FolderSelect,} from '@pages/common-component/folder-select/folder-select.component';
import {FileSelect,} from '@pages/common-component/file-select/file-select.component';
import {ViewPdfWindow,} from '@pages/common-component/view-pdf-window/view-pdf-window.component';

// TODO ToolGen: place import components above here
import {NotAuthorizedComponent,} from './pages/not-authorized/not-authorized.component';
import {ConfirmDialog,} from '@pages/common-component/confirm-dialog/confirm-dialog.component';


import {SMS000Main,} from '@pages/sms000-main/sms000-main';
import {SMS001MainMenu,} from '@pages/sms001-main-menu/sms001-main-menu';
import {SMS002KeiyakuInfo,} from '@pages/sms002-keiyaku-info/sms002-keiyaku-info';
import {SMS003SiharaiEntry,} from '@pages/sms003-siharai-entry/sms003-siharai-entry';
import {SMS004BarcodeLink,} from '@pages/sms004-barcode-link/sms004-barcode-link';
import {SMS005KozaInfo,} from '@pages/sms005-koza-info/sms005-koza-info';
import {SMS006SeikyugakuInfo,} from '@pages/sms006-seikyugaku-info/sms006-seikyugaku-info';
import {SMS007KaiyakuEntry,} from '@pages/sms007-kaiyaku-entry/sms007-kaiyaku-entry';
import {SMS008KingakuInfo,} from '@pages/sms008-kingaku-info/sms008-kingaku-info';
import {SMS009NameUpdate,} from '@pages/sms009-name-update/sms009-name-update';
import {SMS010Completed,} from '@pages/sms010-completed/sms010-completed';
import {SMS011Error,} from '@pages/sms011-error/sms011-error';

// TODO ToolGen: place import components above here
@NgModule({
  declarations: [
    App,
    HeaderComponent,
    NotFoundComponent,
    ConfirmDialog,
    LoadingComponent,
    SnackBarComponent,
    FolderSelect,
    FileSelect,
    ViewPdfWindow,
    YearMonthInputDirective,
    YearMonthDayInputDirective,
    FocusDirective,
    CheckboxErrorState,
    MaxBytesLengthDirective,
    NativeElementInjectorDirective,
    StepChangeDirective,
    YearMonthDayDtpDirective,
    InputRestrictDirective,
    NotAuthorizedComponent,

    // TODO ToolGen: place declare components above here
    SMS000Main,
    SMS001MainMenu,
    SMS002KeiyakuInfo,
    SMS003SiharaiEntry,
    SMS004BarcodeLink,
    SMS005KozaInfo,
    SMS006SeikyugakuInfo,
    SMS007KaiyakuEntry,
    SMS008KingakuInfo,
    SMS009NameUpdate,
    SMS010Completed,
    SMS011Error,

  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    MatNativeDateModule,
    // Angular Material
    MatSidenavModule,
    MatCardModule,
    MatTabsModule,
    MatDividerModule,
    MatSnackBarModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    MatStepperModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatDatepickerModule,
    MatSelectModule,
    MatRadioModule,
    MatCheckboxModule,
    MatSlideToggleModule,
    MatAutocompleteModule,
    AutoCompleteModule,
    MatTooltipModule,
    MatBadgeModule,
    MatTableModule,
    MatPaginatorModule,
    MatGridListModule,
    MatStepperModule,
    MatListModule,
    // Flex-layout
    FlexLayoutModule,
    // Prime NG Modules
    PanelMenuModule,
    TableModule,
    // NgxExtendedPdfViewerModule
    NgxExtendedPdfViewerModule,
  ],
  providers: [
    {provide: MAT_DATE_LOCALE, useValue: 'ja-JP',},
    {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE,],},
    {provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS,},
    // for require error show on dirty
    {provide: ErrorStateMatcher, useClass: ShowOnDirtyErrorStateMatcher,},
    {provide: ErrorHandler, useClass: ThrownErrorHandler,},
    {provide: HTTP_INTERCEPTORS, useClass: RequestInterceptor, multi: true,},
    {provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: {hideRequiredMarker: true,},},
    {provide: MAT_DIALOG_DEFAULT_OPTIONS , useValue: {disableClose: true, autoFocus: true,},},
    SystemConstant,
    ScreenMessageHandler,
    LoginInfoService,
    HanyoMasterService,
    RequestInterceptor,
    HttpClientAsync,
    ScreenDefinitionProvider,
    ThrownErrorHandler,
    ValidationService,
    WindowStack,
    XmlMasterService,
  ],
  bootstrap: [App,],
})
export class AppModule { }
